 <template>
  <div>
    <breadcrumb :crumbs="crumbs">
       <router-link :to="{ name: 'new_customer'}" class="ls-btn-primary ls-float-right ls-no-margin">
        <i class="fa fa-user-plus" aria-hidden="true"></i>
        <span>{{ $t('application.button.include_customer') }}</span>
       </router-link>
    </breadcrumb>
    <flash-message></flash-message>
    <div v-if="!error.status">
      <br clear="all">
      <filter-customers></filter-customers>
      <table class="ls-table ls-table-striped ls-sm-space" v-if="customers.length">
        <thead>
          <tr>
            <th width="10%" class="hidden-xs">{{ $t('customers.attributes.id') }}</th>
            <th width="20%">{{ $t('customers.attributes.client_name') }}</th>
            <th width="20%">{{ $t('customers.attributes.company_name') }}</th>
            <th width="15%" class="hidden-xs">{{ $t('customers.attributes.person_type') }}</th>
            <th width="15%">{{ $t('customers.attributes.status') }}</th>
            <th width="15%">&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <tr data-test="customer" v-for="(customer, index) in customers">
            <td data-test="customers.id" class="hidden-xs">{{ customer.id }}</td>
            <td data-test="customers.name">
              {{ customer.name }}
              <small class="ls-xs-margin-top ls-display-block-lg">{{ customer.email }}</small>
            </td>
            <td data-test="customers.company_name" v-if="customer.company_name">{{ customer.company_name }}</td>
            <td data-test="customers.company_name" v-else> - </td>
            <td data-test="customers.type" class="hidden-xs" v-if="customer.kind === 'P'">{{ $t('customers.show.personal') }}</td>
            <td data-test="customers.type" class="hidden-xs" v-else>{{ $t('customers.show.customer_person') }}</td>
            <td data-test="customers.status" class="active" v-if="customer.active"><span class="ls-display-inline-block">{{ $t('customers.main.active') }}</span></td>
            <td data-test="customers.status" class="inactive" v-else><span class="ls-display-inline-block">{{ $t('customers.main.inactive') }}</span></td>
            <td>
              <regroup :width="1675" class="ls-float-right">
                <router-link slot="button" :to="{ name: 'edit_customer', params: { id: customer.id }}" class="ls-btn ls-no-margin-bottom ls-no-margin-top ls-xs-margin-right">{{ $t('customers.main.edit') }}</router-link>
                <router-link slot="button" :to="{ name: 'customers_details', params: { id: customer.id }}" class="ls-btn ls-no-margin">{{ $t('customers.main.details') }}</router-link>
                <dropdown :list="true" slot="dropdown" :class="'ls-pos-right'">
                  <button slot="trigger" class="ls-btn ls-no-margin-bottom ls-no-margin" role="combobox" aria-expanded="false"></button>
                  <ul slot="list" class="ls-dropdown-nav" aria-hidden="true">
                    <li v-if="customer.active">
                      <authorized-link tag="destroy_customer">
                        <a href="javascript:void(0)" @click="setInactiveData(customer, index)" class="ls-color-danger">{{ $t('application.button.inactive') }}</a>
                      </authorized-link>
                    </li>
                  </ul>
                </dropdown>
              </regroup>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-else>
        <empty-list></empty-list>
      </div>
      <pagination :updater="getCustomers"></pagination>
    </div>
    <modal-inactive v-model="inactiveObjects"></modal-inactive>
  </div>
</template>
<script>
  import Filter from './components/Filter'
  import Breadcrumb from 'src/app/components/shareds/Breadcrumb'
  import { mapActions, mapGetters, mapMutations } from 'vuex'
  import ModalInactive from './components/ModalInactive'
  import Pagination from 'src/app/components/shareds/pagination/Pagination'
  import Dropdown from 'src/app/components/shareds/dropdown/Dropdown'
  import Regroup from 'src/app/components/shareds/regroup/Regroup'
  import filter from 'src/utils/filter'
  import Browser from 'src/utils/browser'
  import _ from 'lodash'
  import scroll from 'src/utils/scroll'
  import EmptyList from 'src/app/components/shareds/empty-list/EmptyList'

  export default {
    name: 'IndexCustomers',
    data () {
      return {
        inactiveObjects: { show: false },
        createContract: { show: false },
        index: null,
        error: false,
        crumbs: {
          'ico': 'ls-ico-users',
          'section': this.$t('customers.main.subscribers_list'),
          'paths': {
            0: {
              'title': this.$t('customers.main.subscribers'),
              'path': ''
            }
          }
        }
      }
    },
    mounted () {
      this.getFromUrl()
      this.getCustomers()
      this.$watch('customers', function (newVal, oldVal) {
        this.setPageData(newVal)
      })
    },
    computed: {
      ...mapGetters(['customers', 'filterCustomers', 'pagination'])
    },
    components: {
      Breadcrumb,
      ModalInactive,
      FilterCustomers: Filter,
      Pagination,
      Dropdown,
      Regroup,
      EmptyList
    },
    beforeDestroy () {
      this.clearFilterCustomers()
    },
    methods: {
      ...mapActions(['loadCustomers']),
      ...mapMutations(['setPageData', 'clearFilterCustomers', 'setCustomer']),
      getCustomers () {
        this.$loader.show()
        var params = filter.toQueryWithPagination(this.filterCustomers, this.pagination, 10)
        this.saveOnUrl()
        this.loadCustomers(params).then(this.afterLoad)
      },
      afterLoad () {
        this.$loader.hide()
      },
      getFromUrl () {
        Browser.recoverFilterFromURL(this.$route, this.filterCustomers, this.pagination)
      },
      saveOnUrl () {
        var paginationUrlParams = { current_page: this.pagination.current_page, per_page: this.pagination.per_page }
        Browser.filtersToURL(this.$router, _.merge(this.filterCustomers, paginationUrlParams), 'customers')
      },
      setInactiveData (customer, index) {
        this.setCustomer(customer)
        this.inactiveObjects.index = index
        this.inactiveObjects.show = true
        this.inactiveObjects.callback = scroll.scrollToFlash
      }
    }
  }
</script>
<style lang="scss">
  .total-item {
    text-align: center;
    position: relative;
    top: 36px;
    margin: 0;
    @media (max-width: 960px) {
      top: 0;
    }
  }
  .inactive {
    background: #f2f2f2!important;
    color: #8c8c8c;
  }
  .active {
    background-color: #b2e1b3!important;
    color: #388f39;
  }
</style>



// WEBPACK FOOTER //
// Main.vue?1e9423e9